import React from 'react'

function InputField ({
    value, title, label, name, placeholder, maxlength, disableInput,
    type, styleClass, attributeHandle, attributeBlur
}) {
    return (
        <div className="inputcol2 nameCol">
            {label && <label htmlFor="input-field">{label}</label> }
            <input type={type} id={name}
                name={name}
                value={value}
                maxLength={maxlength}
                className={styleClass}
                title={title}
                placeholder={placeholder}
                data-valid="required"
                onChange={attributeHandle}
                onBlur={attributeBlur}
                disabled={ disableInput }
            />
        </div>
    )
}

export default InputField
